const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'andromeda',
            client_id: '07-tendermint-17',
            connection_id: 'connection-13'
        },
        chain_2: {
            chain_name: 'kyve',
            client_id: '07-tendermint-2',
            connection_id: 'connection-3'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-14',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                fee_version: 'ics29-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'axelar',
            client_id: '07-tendermint-118',
            connection_id: 'connection-107'
        },
        chain_2: {
            chain_name: 'kyve',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-75',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kyve',
            client_id: '07-tendermint-0',
            connection_id: 'connection-0'
        },
        chain_2: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-2757',
            connection_id: 'connection-2274'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-0',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-767',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kyve',
            client_id: '07-tendermint-3',
            connection_id: 'connection-5'
        },
        chain_2: {
            chain_name: 'source',
            client_id: '07-tendermint-15',
            connection_id: 'connection-16'
        },
        channels: [{
                chain_1: {
                    channel_id: 'channel-3',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                fee_version: 'ics29-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }]
    }
];
export default info;
